import { render, staticRenderFns } from "./buy-service-list.vue?vue&type=template&id=29728d02&scoped=true&"
import script from "./buy-service-list.vue?vue&type=script&lang=js&"
export * from "./buy-service-list.vue?vue&type=script&lang=js&"
import style0 from "./buy-service-list.vue?vue&type=style&index=0&id=29728d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29728d02",
  null
  
)

export default component.exports